<template>
  <Popup :visible="visible" @close="$emit('close')"
         :title="event && event.title != '' && !byIdea ? 'Modifier une action' : 'Ajouter une action'"  
         :add="event && (event.title == '' || byIdea)"
         :update="noButtons"
         :blockOverlay="noButtons"
         @delete="$emit('delete', event); $emit('close')" 
         @add="saveEvent(); $emit('close')" 
         @update="saveEvent(); $emit('close')"    
  >
    <div class="flex gap-4 h-[511px]">
      <div class="w-[500px] h-full flex flex-col">
        <span class=" text-left w-full bg-white px-1 font-bold text-md text-gray-500 mb-2">Informations générales</span>
        <div class="flex flex-col flex-grow gap-8">
          <div class="flex gap-2" v-if="perm().projects != 'none' && perm().clients != 'none'">
            <!-- Select du client -->
            <div class="flex w-full">
              <div class="relative w-full">
                <SelectCombobox
                  v-model="editableEvent.clientId"
                  :options="clientOptions"
                  label="Client"
                  placeholder="Sélectionner un client"
                  :allow-empty="true"
                  :empty-label="'Sélectionner un client'"
                  :display-value="clientDisplay"
                  :showAddOption="true"
                  addOptionLabel="Ajouter un client"
                  @select="onClientSelected"
                  @add-new="onAddClient"
                  :disabled="!!project"
                />
              </div>
            </div>
            <!-- Select du projet -->
            <div class="flex w-full">
              <div class="relative w-full">
              <SelectCombobox
                v-model="editableEvent.projectId"
                :options="projectOptions"
                label="Projet"
                placeholder="Sélectionner un projet"
                :allow-empty="true"
                :empty-label="'Sélectionner un projet'"
                :display-value="projectDisplay"
                :showAddOption="true"
                addOptionLabel="Ajouter un projet"
                :disabled="!!project"
                @select="onProjectSelected"
                @add-new="onAddProject"
              />
              </div>
            </div>
          </div>

          <div class="flex gap-2">
            <!-- Titre -->
            <div class="relative w-4/5">
              <InputCombobox
                v-model="editableEvent.title"
                :options="actionOptions"
                label="Action"
                placeholder="Réunion"
                required
                :isOptionTemplate="isOptionTemplate"
                @select="onOptionSelected"
                @remove-template="removeTemplate"
              />
            </div>

            <!-- Couleur -->
            <div class="relative w-1/5">
              <span class="absolute -top-2 left-2 bg-white px-1 text-xs text-gray-500 !p-0">Couleur</span>
              <input
                type="color"
                v-model="editableEvent.color"
                class="basicInput !p-0 w-full bg-transparent m-0"
              >
            </div>
          </div>
          <div class="flex-1 h-[343px] max-h-[343px]">
            <Ressources :object="editableEvent"/>
            <!-- Bouton modèle -->
            <div class="sticky bg-white z-10 pt-8" v-if="perm().planning == 'modification'">
              <button type="button" class="h-9 !px-4 text-sm flex items-center justify-center cursor-pointer"
              @click="setAsTemplate"
              >
              {{ editableEvent.isTemplate ? 'Supprimer des modèles' : 'Enregistrer comme modèle' }}
              </button>
            </div>
          </div>
          
        </div>
      </div>

      <div class="border border-gray-300"></div>

      <div class="w-[300px] h-full max-h-full overflow-y-auto">
        <template v-if="project && perm().projects != 'none'">
          <span class="block text-left w-full bg-white px-1 font-bold text-md text-gray-500 mb-2">Details dans le projet</span>
          <div class="flex flex-col gap-8">
            <div class="relative w-full">
              <span class="absolute -top-2 left-2 bg-white px-1 text-xs text-gray-500">Section</span>
              <select class="basicInput w-full" v-model="editableEvent.projectSection">
                <option value="" selected disabled>Choisir une section</option>
                <option v-for="section in project.sections" :key="section" :value="section">{{ section }}</option>
              </select>
            </div>

            <div class="relative w-full mb-4 text-left">
              <span class="absolute -top-2 left-2 bg-white px-1 text-xs text-gray-500">Afficher dans le planning global</span>
              <CustomCheckbox 
                v-model="editableEvent.showInGlobalPlanning" 
                class="mt-3 ml-2"/>
            </div>
          </div>
        </template>

        <span class="block text-left w-full bg-white px-1 font-bold text-md text-gray-500 mb-2">Dates</span>
        <div class="flex flex-col gap-8">
          <!-- Debut -->
          <div class="flex gap-2">
            <!-- Date Début -->
            <div class="relative w-full">
              <span class="absolute -top-2 left-2 bg-white px-1 text-xs text-gray-500">Du</span>
              <input class="basicInput w-full" 
                type="date" 
                v-model="startDate" 
                @keydown.prevent   
                @paste.prevent
                @wheel.prevent
                required
              />
            </div>
            <!-- Heure -->
            <div class="relative w-full">
              <span class="absolute -top-2 left-2 bg-white px-1 text-xs text-gray-500">Heure</span>
              <input type="time"
                  v-model="startTime"
                  class="w-full basicInput"
                  ref="focusInput"
                  required
              >
            </div>
          </div>
          <!-- Fin -->
          <div class="flex gap-2">
            <!-- Date Fin -->
            <div class="relative w-full">
              <span class="absolute -top-2 left-2 bg-white px-1 text-xs text-gray-500">Au</span>
              <input class="basicInput w-full" 
                type="date" 
                v-model="endDate" 
                @keydown.prevent   
                @paste.prevent
                @wheel.prevent
                required
              />
            </div>
            <!-- Heure -->
            <div class="relative w-full">
              <span class="absolute -top-2 left-2 bg-white px-1 text-xs text-gray-500">Heure</span>
              <input type="time"
                  v-model="endTime"
                  class="w-full basicInput"
                  ref="focusInput"
                  required
              >
            </div>
          </div>
          <div class="relative w-full">
            <span class="absolute -top-2 left-2 bg-white px-1 text-xs text-gray-500">Temps d'accès</span>
            <input type="time"
                v-model="editableEvent.accessTime"
                class="w-full basicInput"
                ref="focusInput"
            >
          </div>
        </div>
        <div v-if="perm().mainReminders != 'none'">
          <span class="block text-left w-full bg-white px-1 font-bold text-md text-gray-500 mt-8">Rappels</span>
          <div class="flex flex-col gap-4 mt-2">
            <div class="flex gap-2" v-for="(reminder, index) in editableEvent.reminders" :key="index">
              <!-- Date -->
              <div class="relative w-full">
                <span class="absolute -top-2 left-2 bg-white px-1 text-xs text-gray-500">Le</span>
                <input class="basicInput w-full" 
                  type="date" 
                  v-model="reminder.date" 
                  @keydown.prevent   
                  @paste.prevent
                  @wheel.prevent
                  required
                />
              </div>
              <!-- Heure -->
              <div class="relative w-full">
                <span class="absolute -top-2 left-2 bg-white px-1 text-xs text-gray-500">À</span>
                <input type="time"
                    v-model="reminder.hour"
                    placeholder="Dupont"
                    class="w-full basicInput"
                    ref="focusInput"
                    required
                >
              </div>
              <span class="cursor-pointer text-gray-700 flex items-center" @click="editableEvent.reminders = editableEvent.reminders.filter((_, i) => i !== index)">
                <i class="fas fa-times"></i>
              </span>
            </div>
          </div>
          <button
            type="button"
            class="h-9 w-full !px-4 text-sm flex items-center justify-center cursor-pointer text-gray-500 !m-0 !mt-2 !font-normal !bg-transparent hover:!bg-gray-100 rounded-lg"
            v-if="editableEvent.reminders.length < 3"
            @click="addReminder"
          >+ Ajouter un rappel</button>
        </div>
      </div>

      <div class="border border-gray-300"></div>

      <div class="w-[350px] flex flex-col z-1001">
        <span class="block text-left w-full bg-white px-1 font-bold text-md text-gray-500 mb-2">Tâches</span>
        <div class="overflow-y-auto flex-grow w-full" @wheel.stop>
          <div
            v-for="task in editableEvent.tasks"
            :key="task.id"
            class="w-full mb-2 rounded-xl px-0 py-2"
            :class="{ 'bg-red-200': task.isFinished }"
          >
            <!-- Ligne principale de tâche -->
            <div class="flex gap-2 items-top h-fit mb-1">
              <span class="flex flex-col !m-0 !p-0 ">
                <button type="button" @click="moveTaskUp(task)" @click.stop :disabled="task.id === 0" class="!m-0 !p-0 !h-6 !w-8 !bg-transparent cursor-pointer"><i class="fas fa-chevron-up !h-4 !w-4"></i></button>
                <button type="button" @click.stop="moveTaskDown(task)" :disabled="task.id === editableEvent.tasks.length - 1" class="!m-0 !p-0 !h-6 !w-8 !bg-transparent cursor-pointer"><i class="fas fa-chevron-down !h-4 !w-4"></i></button>
              </span>
              <!-- Icône flèche pour afficher/masquer les sous-tâches -->
              <span class="cursor-pointer mt-3" @click.stop="toggleSubTasks(task)">
                <i
                  class="h-4 w-4"
                  :class="{
                    'fas fa-chevron-down': task.subTasksVisible !== false,
                    'fas fa-chevron-right': task.subTasksVisible === false
                  }"
                ></i>
              </span>
              <CustomCheckbox :modelValue="task.isFinished" v-model="task.isFinished" class="mt-3"/>
              <textarea
                type="text"
                v-model="task.content"
                class="w-full max-h-64 px-1 py-1 resize-none mt-2 self-start"
                placeholder="Nom de la tâche"
                ref="taskInputs"
                rows="1"
                @input="autoResize($event)"
              ></textarea>
              <span class="cursor-pointer text-gray-700 mr-2 mt-3" @click="editableEvent.tasks = editableEvent.tasks.filter(t => t.id !== task.id)">
                <i class="fas fa-times"></i>
              </span>
            </div>
            <!-- Liste des sous-tâches (affichée en dessous) -->
            <div v-if="task.subTasksVisible !== false" class="ml-20">
              <div
                v-for="subTask in task.subTasks"
                :key="subTask.id"
                class="flex gap-2 mb-1 rounded-xl pl-2 p-2"
                :class="{ 'bg-red-200': subTask.isFinished }"
              >
                <CustomCheckbox :modelValue="subTask.isFinished" v-model="subTask.isFinished" class="self-start mt-1"/>
                <textarea
                  type="text"
                  v-model="subTask.content"
                  class="w-full max-h-64 px-1 py-1 resize-none self-start"
                  placeholder="Nom de la sous-tâche"
                  ref="subtaskInputs"
                  rows="1"
                  @input="autoResize($event)"
                ></textarea>
                <span class="cursor-pointer text-gray-700 self-start mt-1" @click="task.subTasks = task.subTasks.filter(st => st.id !== subTask.id)">
                  <i class="fas fa-times"></i>
                </span>
              </div>
              <div>
                <div class="flex items-center gap-2 cursor-pointer ml-3 text-gray-600 mt-1" @click="addSubTask(task)">
                  <i class="fas fa-plus"></i>
                  <span class="">Ajouter une sous-tâche</span>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="flex justify-center mt-2">
          <button
            type="button"
            class="callToAction h-9 w-full !px-4 text-sm flex items-center !mx-0 !ml-2"
            @click="addTask"
          >
            Ajouter une tâche
          </button>
        </div>
        <span class="block text-left w-full bg-white px-1 font-bold text-md text-gray-500 mb-2 mt-4">Compte rendu</span>
        <textarea class="basicInput px-1 min-h-[150px] resize-none" v-model="editableEvent.report"></textarea>
      </div>
    </div>
  </Popup>

  <PopupClient class="z-10"
    :visible="popupClientVisible" 
    @close="popupClientVisible = false" 
    @add="addClient"
  />

  <PopupProject
    class="z-10"
    :visible="popupProjectVisible"
    @close="popupProjectVisible = false"
    @add="addProject"
  />
</template>

  
<script>
import Popup from '@/components/Popups/Popup.vue';
import PopupClient from './PopupClient.vue';
import PopupProject from './PopupProject.vue';
import CustomCheckbox from '../Others/CustomCheckbox.vue';
import Ressources from '../Projet/ProjectDetails/Ressources/Ressources.vue';

import InputCombobox from '../Others/InputCombobox.vue';
import SelectCombobox from '../Others/SelectCombobox.vue';


import { fetchRessources } from '@/services/ressourceService';
import { fetchProjects, fetchProjectDetails, addProject, updateProject } from '@/services/projectService';
import { fetchClients, addClient } from '@/services/clientService';

import { addEvent, updateEvent, updateAllEvents } from '@/services/eventService';

import { inject } from 'vue';

export default {
  props: ['event', 'project', 'visible', 'byIdea'],
  components:
  {
    Popup,
    PopupClient,
    PopupProject,
    CustomCheckbox,
    Ressources,
    InputCombobox,
    SelectCombobox,
  },
  setup() {
    const events = inject('events', []);
    const perm = inject('userPerm', () => ({}));
    return { events, perm };
  },
  emits: ['delete', 'close', 'add', 'update'],
  data() {
    return {
      editableEvent: {}, // Copie de l'événement passé en props
      startDate: '',
      startTime: '',
      endDate: '',
      endTime: '',
      ressources: [], // Liste des ressources à charger
      teams: [], // Liste des équipes à charger
      projects: [],
      clients: [],
      popupWidth: 250,
      popupHeight: 350,
      clickedRessource: null,
      selectedRessource: '',
      clientSelectedFirst: false,
      popupClientVisible: false,
      popupProjectVisible: false,
    };
  },
  computed: {
    noButtons() {
      return this.perm().planning !== 'modification';
    },
    clientOptions() {
      return this.clients.map(client => ({
        value: client.id,
        label: client.contacts[0].lastName + ' ' + client.contacts[0].firstName
      }));
    },
    clientDisplay() {
      return (id) => {
        const client = this.clients.find(c => c.id === id);
        return client ? client.contacts[0].lastName + ' ' + client.contacts[0].firstName : '';
      }
    },
    filteredResources() {
      if (this.editableEvent.ressources) {
        return this.ressources.filter(ressource => 
          !this.editableEvent.ressources.some(r => r.ressourceId === ressource.id)
        );
      }
      
      return this.ressources;
    },
    filteredProjects() {
      if (this.clientSelectedFirst && this.editableEvent.clientId) {
        return this.projects.filter(
          proj => proj.clientId === this.editableEvent.clientId
        );
      }
      return this.projects;
    },
    projectOptions() {
      return this.filteredProjects.map(proj => ({
        value: proj.id,
        label: proj.name
      }));
    },
    projectDisplay() {
      return (id) => {
        const proj = this.projects.find(p => p.id === id);
        return proj ? proj.name : '';
      }
    },
    filteredActionOptions() {
      if (!this.query) return this.actionOptions;
      return this.actionOptions.filter(option =>
        option.toLowerCase().replace(/\s+/g, '').includes(this.query.toLowerCase().replace(/\s+/g, ''))
      );
    },
    eventRessources(){
      if(this.editableEvent && this.editableEvent.ressources) {
        const eventR = this.editableEvent.ressources.map(ressource => {
          const foundRessource = this.ressources.find(r => r.id === ressource.ressourceId);
          return foundRessource ? { ...foundRessource, ...ressource} : null;
        }).filter(ressource => ressource !== null);

        return eventR;
      }
      return [];
    },
    templateEvent(){
      const templateEvent = this.events.filter(e => e.isTemplate === true && e.isTemplate);
      return templateEvent;
    },
    actionOptions() {
      const options = this.templateEvent.map(e => e.title).filter((v, i, a) => v && a.indexOf(v) === i);
      return options;
    },
    isSectionEvent() {
      return !!(this.event && this.event.projectSection);
    },
  },
  methods: {
    async loadOptions() {
      this.ressources = await fetchRessources();
      this.projects = await fetchProjects();
      this.clients = await fetchClients();

      this.teams = this.ressources
      .map(ressource => ressource.team)
      .filter((value, index, self) => value !== "" && self.indexOf(value) === index);
    },
    async setAsTemplate() {
      if (this.editableEvent.isTemplate) {
        // Si déjà modèle, on le retire simplement
        this.editableEvent.isTemplate = false;
        await updateEvent(this.editableEvent);
        return;
      }
      // Sinon, on active ce modèle et désactive les autres du même titre
      const otherTemplate = this.events.find(
        e => e.isTemplate && e.title === this.editableEvent.title && e.id !== this.editableEvent.id
      );
      if (otherTemplate) {
        otherTemplate.isTemplate = false;
        await updateEvent(otherTemplate);
      }
      this.editableEvent.isTemplate = true;
      await updateEvent(this.editableEvent);
    },
    setDatas(){
      if(!this.event) {
        return;
      }
      else{
        this.editableEvent = JSON.parse(JSON.stringify(this.event));
        if (!this.editableEvent.ressources) {
          this.editableEvent.ressources = [];
        }
        if(!this.editableEvent.reminders){
          this.editableEvent.reminders = [];
        }
        if(!this.editableEvent.showInGlobalPlanning){
          this.editableEvent.showInGlobalPlanning = true;
        }
        // Force client et projet si prop project existe
        if (this.project) {
          this.editableEvent.projectId = this.project.id;
          this.editableEvent.clientId = this.project.clientId;
        }
      }

      this.query = this.editableEvent.title || '';
      this.optionSelected = false; // Réinitialiser l'état de sélection de l'option
      this.startDate = this.formatDate(this.editableEvent.startDate, 'date');
      this.startTime = this.formatDate(this.editableEvent.startDate, 'time');
      this.endDate = this.formatDate(this.editableEvent.endDate, 'date');
      this.endTime = this.formatDate(this.editableEvent.endDate, 'time');
    },
    autoResize(event) {
      const textarea = event.target;
      textarea.style.height = 'auto';
      textarea.style.height = textarea.scrollHeight + 'px';
    },
    formatDate(datetimeString, type) {
      if (!datetimeString) return '';
      const dateObj = new Date(datetimeString);
      if (type === 'date') {
        return dateObj.toISOString().slice(0, 10); // Format YYYY-MM-DD
      } else if (type === 'time') {
        return dateObj.toTimeString().slice(0, 5); // Format HH:MM
      }
    },
    parseDate(date, time) {
      return `${new Date(`${date}T${time}:00`)}`;
    },
    async saveEvent() {
      console.log("Saving event", this.editableEvent);
      this.editableEvent.startDate = this.parseDate(this.startDate, this.startTime);
      this.editableEvent.endDate = this.parseDate(this.endDate, this.endTime);

      // Si l'événement courant est un template et qu'un autre template a le même title, on désactive isTemplate
      if (
        this.editableEvent.isTemplate &&
        this.events.some(e => e.isTemplate && e.title === this.editableEvent.title && e.id !== this.editableEvent.id)
      ) {
        this.editableEvent.isTemplate = false;
      }

      if(this.byIdea){
        await addEvent(this.editableEvent);
        return;
      }

      if(this.event.title == ""){
        console.log("Adding new event");
        const newEvents = await addEvent(this.editableEvent);
        this.events.push(newEvents[0]);
        this.events.push(newEvents[1]);
        this.$emit('add', newEvents[1]);
      } 
      else{
        const foundEvent = this.events.find(e => e.id === this.editableEvent.id);
        console.log("Found event to update:", foundEvent);
        if (!foundEvent) return;
        // Mettre à jour l'événement avec les données du paramètre
        Object.assign(foundEvent, this.editableEvent);
        // Mettre à jour l'événement dans le service
        if (foundEvent.accessId) {
          const accessEvent = this.events.find(e => e.id === foundEvent.accessId);
          if (accessEvent) {
            // Recalcule les dates d'accès
            const accessTime = foundEvent.accessTime || "00:00";
            const [hours, minutes] = accessTime.split(':').map(Number);
            const accessTimeInMs = (hours * 60 + minutes) * 60 * 1000;
            const startDate = new Date(foundEvent.startDate);
            const endDate = new Date(foundEvent.endDate);

            accessEvent.startDate = new Date(startDate.getTime() - accessTimeInMs - 1).toString();
            accessEvent.endDate = new Date(endDate.getTime() + accessTimeInMs).toString();
            accessEvent.ressources = foundEvent.ressources;
            accessEvent.clientId = foundEvent.clientId;
            accessEvent.projectId = foundEvent.projectId;
            accessEvent.projectSection = foundEvent.projectSection;
            accessEvent.title = foundEvent.title;
            accessEvent.showInGlobalPlanning = foundEvent.showInGlobalPlanning;
            await updateEvent(accessEvent);
          }
        }
        await updateEvent(this.editableEvent);
        this.$emit('update')
      } 
    },
    async updateEventTasks(){
      if(this.byIdea){
        return;
      }

      // Ajoute cette ligne de sécurité :
      if (!this.events || !Array.isArray(this.events)) return;

      const foundEvent = this.events.find(e => e.id === this.editableEvent.id);
      if (!foundEvent) return;

      await updateEvent({ ...foundEvent, tasks: JSON.parse(JSON.stringify(this.editableEvent.tasks)) });
    },
    toggleSubTasks(task) {
      // Bascule l'affichage des sous-tâches pour la tâche concernée
      task.subTasksVisible = !(task.subTasksVisible !== false);
      this.$nextTick(() => {
        const subtaskInputs = this.$refs.subtaskInputs;
        if (subtaskInputs) {
          (Array.isArray(subtaskInputs) ? subtaskInputs : [subtaskInputs]).forEach(textarea => {
            if (textarea) {
              textarea.style.height = 'auto';
              textarea.style.height = textarea.scrollHeight + 'px';
            }
          });
        }
      });
    },
    addTask() {
      // Ajoute une nouvelle tâche à l'événement
      const newTask = { id: this.editableEvent.tasks.length, content: '', isFinished: false, subTasks: [] };
      this.editableEvent.tasks.push(newTask);
      this.$nextTick(() => {
        const taskInputs = this.$refs.taskInputs;
        if (taskInputs && taskInputs.length > 0) {
          taskInputs[taskInputs.length - 1].focus();
        }
      });
    },
    addSubTask(task) {
      // Ajoute une nouvelle sous-tâche à la tâche concernée
      const newSubTask = { id: task.subTasks.length, content: '', isFinished: false };
      task.subTasks.push(newSubTask);
      this.$nextTick(() => {
        const taskInputs = this.$refs.subtaskInputs;
        if (taskInputs && taskInputs.length > 0) {
          taskInputs[taskInputs.length - 1].focus();
        }
      });
    },
    moveTaskUp(task) {
      const tasks = this.editableEvent.tasks;
      const idx = tasks.indexOf(task);
      if (idx > 0) {
        tasks.splice(idx - 1, 0, tasks.splice(idx, 1)[0]);
        // Réattribuer les ids
        tasks.forEach((t, i) => t.id = i);
      }
    },
    moveTaskDown(task) {
      const tasks = this.editableEvent.tasks;
      const idx = tasks.indexOf(task);
      if (idx < tasks.length - 1) {
        tasks.splice(idx + 1, 0, tasks.splice(idx, 1)[0]);
        // Réattribuer les ids
        tasks.forEach((t, i) => t.id = i);
      }
    },
    addRessourceToEvent(){
      if(this.selectedRessource == 'all'){
        this.editableEvent.ressources = this.ressources.map(ressource => ({ ressourceId: ressource.id }));
      } 
      else if(this.teams.includes(this.selectedRessource)){
        const ressourceInTeam = this.ressources.filter(ressource => ressource.team === this.selectedRessource);
        for(const ressource of ressourceInTeam){
          if(!this.editableEvent.ressources.some(r => r.ressourceId === ressource.id)){
            // Si la ressource n'est pas déjà présente, on l'ajoute
            this.editableEvent.ressources.push({ ressourceId: ressource.id });
          }
        }
      }
      else{
        this.editableEvent.ressources.push({ ressourceId: this.selectedRessource }); 
      }

      this.selectedRessource = ''
    },
    async fetchProjectClient(projectId) {
      const projectDetails = await fetchProjectDetails(projectId);
      if (projectDetails && projectDetails.clientId) {
        this.editableEvent.clientId = projectDetails.clientId;
      } else {
        this.editableEvent.clientId = "none"; // Valeur spéciale pour indiquer aucun client
      }
    },
    getClient(clientId) {
      return this.clients.find(client => client.id === clientId);
    },
    async addClient(client) {
      if (!client) return;
      const newClient = await addClient(client);
      this.clients.push(newClient);
      this.editableEvent.clientId = newClient.id;
    },
    addReminder() {
      // Récupère la date de début de l'événement
      const eventDate = new Date(this.startDate + 'T' + this.startTime);

      let reminderDate = new Date(eventDate);
      if (this.editableEvent.reminders.length === 0) {
        // 30 minutes avant
        reminderDate.setMinutes(reminderDate.getMinutes() - 30);
      } else if (this.editableEvent.reminders.length === 1) {
        // 1 jour avant
        reminderDate.setDate(reminderDate.getDate() - 1);
      } else if (this.editableEvent.reminders.length === 2) {
        // 1 semaine avant
        reminderDate.setDate(reminderDate.getDate() - 7);
      } else {
        // Pas plus de 3 rappels
        return;
      }

      // Formate la date et l'heure
      const date = reminderDate.toISOString().slice(0, 10);
      const hour = reminderDate.toTimeString().slice(0, 5);

      this.editableEvent.reminders.push({ date, hour, sent: false });
    },
    onOptionSelected(value) {
      this.optionSelected = true;
      this.editableEvent.title = value;
      // Cherche le modèle correspondant
      const template = this.events.find(e => e.isTemplate && e.title === value);
      if (template) {
        // Appliquer la couleur du modèle
        if (template.color) {
          this.editableEvent.color = template.color;
        }
        // Copier les tâches et sous-tâches, en les décomplétant
        if (template.tasks) {
          this.editableEvent.tasks = template.tasks.map(task => ({
            ...task,
            isFinished: false,
            subTasks: task.subTasks
              ? task.subTasks.map(sub => ({ ...sub, isFinished: false }))
              : []
          }));
        }

        if (template.ressources) {
          // Ajoute les ressources du modèle à celles déjà présentes, sans doublons (par ressourceId), copie profonde
          const current = this.editableEvent.ressources ? JSON.parse(JSON.stringify(this.editableEvent.ressources)) : [];
          const templateRessources = JSON.parse(JSON.stringify(template.ressources));
          const merged = [...current];
          templateRessources.forEach(r => {
            if (!merged.some(cr => cr.ressourceId === r.ressourceId)) {
              merged.push(r);
            }
          });
          this.editableEvent.ressources = merged;
        }
      }
    },
    isOptionTemplate(option) {
      // Vérifie s'il existe un event template avec ce titre
      return this.events.some(e => e.isTemplate && e.title === option);
    },
    async removeTemplate(option) {
      // Trouve l'event concerné et met isTemplate à false
      const eventToUpdate = this.events.find(e => e.isTemplate && e.title === option);
      if (eventToUpdate) {
        eventToUpdate.isTemplate = false;
        await updateEvent(eventToUpdate);
        // Optionnel : forcer le rafraîchissement de la liste si besoin
        this.$forceUpdate?.();
      }
    },
    onClientSelected(clientId) {
      console.log("Client selected:", clientId);
      if (!clientId) {
        // Client remis à vide
        this.editableEvent.clientId = '';
        this.editableEvent.projectId = '';
        this.clientSelectedFirst = false;
      } else {
        // Client sélectionné
        this.editableEvent.clientId = clientId;
        this.clientSelectedFirst = true;
        // On vide le projet pour forcer la sélection d'un projet du client
        this.editableEvent.projectId = '';
      }
    },
    onProjectSelected(projectId) {
      console.log("Project selected:", projectId);
      this.editableEvent.projectId = projectId || '';
      // Si on remet le projet à vide, tu peux ajouter une logique si besoin
    },
    onAddClient() {
      this.popupClientVisible = true;
    },
    onAddProject() {
    this.popupProjectVisible = true;
    },
    async addProject(project) {
      if (!project) return;
      const newProject = await addProject();
      newProject.name = project.name;
      newProject.clientId = this.editableEvent.clientId;
      this.projects.push(newProject);

      this.editableEvent.projectId = newProject.id;
      this.popupProjectVisible = false;

      updateProject(newProject);
    },
  },
  mounted() {
    this.loadOptions(); // Charger les options des selects au montage
    // Initialisation de la visibilité des sous-tâches
    if (this.editableEvent && this.editableEvent.tasks) {
      this.editableEvent.tasks.forEach(task => {
        // Si la tâche est finie, on ferme (cache) ses sous-tâches par défaut
        if (task.isFinished) {
          task.subTasksVisible = false;
        } else if (typeof task.subTasksVisible === 'undefined') {
          task.subTasksVisible = true;
        }
      });
    }
  },
  watch:{
    event: {
      handler() {
        // À chaque changement de 'event', on appelle setDatas
        this.setDatas();
        this.$nextTick(() => {
          // Auto-resize sur toutes les textarea référencées
          const taskInputs = this.$refs.taskInputs;
          if (taskInputs) {
            // Si plusieurs refs (v-for), c'est un tableau
            (Array.isArray(taskInputs) ? taskInputs : [taskInputs]).forEach(textarea => {
              if (textarea) {
                textarea.style.height = 'auto';
                textarea.style.height = textarea.scrollHeight + 'px';
              }
            });
          }
          // Pareil pour les sous-tâches si besoin
          const subtaskInputs = this.$refs.subtaskInputs;
          if (subtaskInputs) {
            (Array.isArray(subtaskInputs) ? subtaskInputs : [subtaskInputs]).forEach(textarea => {
              if (textarea) {
                textarea.style.height = 'auto';
                textarea.style.height = textarea.scrollHeight + 'px';
              }
            });
          }
        });
      },
      immediate: true, // Appeler la fonction immédiatement lors de la première exécution
      deep: true, // Observer les changements profonds de l'objet
    },
    'editableEvent.clientId': {
      handler(newVal) {
        if (this.isSectionEvent) return; // <-- Ajout
        // Si on remet le client à vide, on vide aussi le projet
        if (newVal === '') {
          this.editableEvent.projectId = '';
          this.clientSelectedFirst = false;
          return;
        }
        if (!this.editableEvent.projectId) {
          // On active le filtrage SEULEMENT si aucun projet n'est sélectionné
          this.clientSelectedFirst = true;
          this.editableEvent.projectId = '';
        } else {
          // Si un projet est déjà sélectionné, on ne filtre pas
          this.clientSelectedFirst = false;
        }
      },
      deep: true
    },
    'editableEvent.tasks': {
      handler() {
        this.updateEventTasks();
      },
      deep: true, // Observer les changements profonds de l'objet
    },
    'editableEvent.projectId': {
			immediate: true,
			async handler(newProjectId) {
        if (this.isSectionEvent) return; // <-- Ajout
				if (newProjectId) {
					// Ne désactive le filtrage QUE si on n'a pas commencé par le client
					if (!this.clientSelectedFirst) {
						this.clientSelectedFirst = false;
					}
					await this.fetchProjectClient(newProjectId);
				} else if (!this.clientSelectedFirst) {
          this.editableEvent.clientId = "";
        }
			}
		},
    startDate(newStart, oldStart) {
      if (!newStart || !this.endDate) return;
      const start = new Date(newStart);
      const end = new Date(this.endDate);
      // Si la date de fin est avant la date de début, on la décale du même nombre de jours
      if (end < start) {
        // Décale la date de fin pour garder l'écart initial
        const oldStartDate = new Date(oldStart);
        const oldEndDate = new Date(this.endDate);
        const diff = oldEndDate - oldStartDate;
        const newEnd = new Date(start.getTime() + diff);
        this.endDate = newEnd.toISOString().slice(0, 10);
      }
      // Si même date, vérifier l'heure
      if (this.endDate === newStart && this.endTime <= this.startTime) {
        this.endTime = this.startTime;
      }
    },
    startTime(newStart, oldStart) {
      if (this.startDate === this.endDate) {
        const [h2, m2] = newStart.split(':').map(Number);
        const [eh, em] = this.endTime.split(':').map(Number);
        const startMinutes = h2 * 60 + m2;
        const endMinutes = eh * 60 + em;

        // Seulement si l'heure de début dépasse ou égale l'heure de fin
        if (startMinutes >= endMinutes) {
          // Calcul de l'écart initial
          const [h1, m1] = oldStart ? oldStart.split(':').map(Number) : [0, 0];
          const delta = endMinutes - (h1 * 60 + m1);

          let newEndMinutes = startMinutes + (delta > 0 ? delta : 1);
          if (newEndMinutes > 1439) newEndMinutes = 1439;

          // Si delta <= 0, on force +1 minute
          if (delta <= 0) newEndMinutes = startMinutes + 1;

          const newEndH = String(Math.floor(newEndMinutes / 60)).padStart(2, '0');
          const newEndM = String(newEndMinutes % 60).padStart(2, '0');
          this.endTime = `${newEndH}:${newEndM}`;
        }
      }
    },
    endDate(newEnd) {
      if (!newEnd || !this.startDate) return;
      const start = new Date(this.startDate);
      const end = new Date(newEnd);
      if (end < start) {
        this.endDate = this.startDate;
      }
      // Si même date, vérifier l'heure
      if (newEnd === this.startDate && this.endTime <= this.startTime) {
        this.endTime = this.startTime;
      }
    },
    endTime(newEnd) {
      if (this.startDate === this.endDate && newEnd <= this.startTime) {
        const [h, m] = this.startTime.split(':').map(Number);
        let endMinutes = h * 60 + m + 1;
        if (endMinutes > 1439) endMinutes = 1439; // max 23:59
        const newEndH = String(Math.floor(endMinutes / 60)).padStart(2, '0');
        const newEndM = String(endMinutes % 60).padStart(2, '0');
        this.endTime = `${newEndH}:${newEndM}`;
      }
    },
  }
};
</script>

<style scoped>
input[type="color"] {
-webkit-appearance: none;
}
input[type="color"]::-webkit-color-swatch-wrapper {
padding: 8px;
}
input[type="color"]::-webkit-color-swatch {
border: none;
border-radius: 8px;
}
</style>